export const TRAIN_IMAGES = [
	require('../assets/images/trains/01yamanote.png'),
	require('../assets/images/trains/02keihintouhoku.png'),
	require('../assets/images/trains/03keiyou.png'),
	require('../assets/images/trains/04saikyou.png'),
	require('../assets/images/trains/05jouban.png'),
	require('../assets/images/trains/06soubu.png'),
	require('../assets/images/trains/07chuou.png'),
	require('../assets/images/trains/08yokohama.png'),
	require('../assets/images/trains/10toukaidou.png'),
	require('../assets/images/trains/11musashino.png'),
	require('../assets/images/trains/12nanbu.png'),
	require('../assets/images/trains/13yokosuka.png'),
	require('../assets/images/trains/14touhoku.png'),
];
